import ExcelJS from "exceljs";
import dataDownloaderWorker from "../../workers/dataDownloaderWorker";
import WebWorker from "../../workers/WebWorker";
import { saveExcelFile } from "../../utils/Utils";
import { CURRENCY_UNITS } from "../../constants/global.constants";
import { MASS_KEYS } from "../../constants/global.constants";
import {
  createProcessedDataExcelSheet,
  processCleanDataForExcel,
} from "./processedDataSheet";
import { cleanedData } from "../../network/cipAPI";

const createCleaningAdvisorExcelSheet = (
  workbook,
  sheetData,
  columns,
  sheetName,
  t,
  transposeData = false,
  suggestedData = null,
) => {
  const excelSheet = workbook.addWorksheet(sheetName);
  let messages = [];
  if (Array.isArray(sheetData) && sheetData.length > 0) {
    if (transposeData) {
      if (columns.length === sheetData.length) {
        for (let i = 0; i < columns.length; i++) {
          const suggestedValue =
            suggestedData && suggestedData[i] != null ? suggestedData[i] : "";
          const row = excelSheet.addRow([
            columns[i],
            sheetData[i],
            suggestedValue,
          ]);
          row.getCell(1).font = { bold: true };
          row.getCell(2).alignment = { horizontal: "right" };
          if (suggestedData) {
            row.getCell(3).alignment = { horizontal: "right" };
          }
        }
        excelSheet.getColumn(1).width = 50;
        if (suggestedData) {
          excelSheet.getColumn(2).width = 20;
          excelSheet.getColumn(3).width = 20;
        }
      }
    } else {
      excelSheet.getRow(1).font = { bold: true };
      excelSheet.columns = Object.keys(columns).map((key) => ({
        key,
        header: columns[key],
        width: 20,
      }));
      excelSheet.addRows(sheetData);
    }
  }

  if (
    sheetName === t("excelSheetNames.cleaningEffectivness") &&
    Array.isArray(sheetData) &&
    sheetData.length > 0
  ) {
    let greaterThan100MessageAdded = false;
    let lessThan0MessageAdded = false;
    let containsAsteriskMessageAdded = false;
    let datapresentmessage = false;
    let flagEMessageAdded = false;
    let flagRMessageAdded = false;
    let flagWMessageAdded = false;

    sheetData.forEach((row) => {
      ["pressure_drop", "flow", "salt_passage"].forEach((colKey) => {
        const cellValue = row[colKey];
        const flags = row[`${colKey}_flags`] || [];
        if (!datapresentmessage && String(cellValue)) {
          messages.push(` ${t("cleaningEffectivnessStrings.note")}`);
          datapresentmessage = true;
        }
        if (
          !greaterThan100MessageAdded &&
          String(cellValue).includes("> 100")
        ) {
          messages.push(
            ` ${t("cleaningEffectivnessStrings.noteForValuesrGeaterThan100")}`,
          );
          greaterThan100MessageAdded = true;
        }
        if (!lessThan0MessageAdded && String(cellValue).includes("< 0")) {
          messages.push(
            ` ${t("cleaningEffectivnessStrings.noteForValuesLessThan0")}`,
          );
          lessThan0MessageAdded = true;
        }
        if (!containsAsteriskMessageAdded && String(cellValue).includes("*")) {
          messages.push(`${t("cleaningEffectivnessStrings.noteWith*")}`);
          containsAsteriskMessageAdded = true;
        }
        if (!flagEMessageAdded && Array.isArray(flags) && flags.includes("E")) {
          messages.push(`${t("cleaningEffectivnessStrings.footnoteE")}`);
          flagEMessageAdded = true;
        }
        if (!flagRMessageAdded && Array.isArray(flags) && flags.includes("R")) {
          messages.push(`${t("cleaningEffectivnessStrings.footnoteR")}`);
          flagRMessageAdded = true;
        }
        if (!flagWMessageAdded && Array.isArray(flags) && flags.includes("W")) {
          messages.push(`${t("cleaningEffectivnessStrings.footnoteW")}`);
          flagWMessageAdded = true;
        }
      });
    });
    if (messages.length > 0) {
      excelSheet.addRow();
      excelSheet.addRow();
      messages.forEach((msg) => {
        excelSheet.addRow([msg]).font = { bold: true };
      });
    }
  }

  if (
    sheetName === t("excelSheetNames.fouling") &&
    Array.isArray(sheetData) &&
    sheetData.length > 0
  ) {
    excelSheet.addRow();
    excelSheet.addRow();
    const msg = `${t("foulingStrings.scoreDescription")}`;
    excelSheet.addRow([msg]).font = { bold: true };
  }

  if (sheetName === t("excelSheetNames.others")) {
    // Only insert divider if we have enough rows
    if (excelSheet.rowCount >= 47) {
      excelSheet.insertRow(47);
      const dividerRow = excelSheet.insertRow(48);
      excelSheet.insertRow(49);
      dividerRow.height = 30;
      dividerRow.getCell("A").value = t("analyseData.settings");
      dividerRow.getCell("A").font = { bold: true, size: 12 };
      if (suggestedData) {
        dividerRow.getCell("B").value =
          t("excelSheetNames.othersColumnCurrentValue") || "Current";
        dividerRow.getCell("B").font = { bold: true, size: 12 };
        dividerRow.getCell("C").value =
          t("excelSheetNames.othersColumnSuggestedValue") || "Suggested";
        dividerRow.getCell("C").font = { bold: true, size: 12 };
      }
      dividerRow.border = {
        top: { style: "medium", color: { argb: "FFD3D3D3" } },
        bottom: { style: "medium", color: { argb: "FFD3D3D3" } },
      };
    }
  }
};

const createCleaningAdvisorPredictExcelSheet = (
  workbook,
  sheetName,
  dataSets,
  messages,
  t,
) => {
  const excelSheet = workbook.addWorksheet(sheetName);
  let currentRow = 1;
  const columnStyle = {
    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } },
    font: { color: { argb: "000000" } },
    border: {
      top: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    },
  };

  if (Array.isArray(dataSets)) {
    dataSets.forEach((dataSet, dataSetIndex) => {
      if (Array.isArray(dataSet) && dataSet.length > 0) {
        const message = messages[dataSetIndex] || "";
        const startCol = 0;
        const endCol =
          startCol + dataSet[0] && Array.isArray(dataSet[0])
            ? dataSet[0].length - 1
            : Object.keys(dataSet[0] || {}).length - 1;

        if (message) {
          excelSheet.addRow();
          excelSheet.addRow();
          excelSheet.addRow([message], { font: { bold: true } });
          currentRow++;
        }
        excelSheet.addTable({
          name: `Table_${dataSetIndex + 1}`,
          ref: `${String.fromCharCode(
            65 + startCol,
          )}${currentRow}:${String.fromCharCode(65 + endCol)}${
            currentRow + dataSet.length - 1
          }`,
          columns: Object.keys(dataSet[0])?.map((col, colIndex) => ({
            name: t(`PredictAndRecommendStrings.${col}`),
            style: columnStyle,
          })),
          rows: dataSet.map((row) => Object.values(row)),
        });
        excelSheet.properties.defaultColWidth = 20;
        excelSheet.properties.showGridLines = true;
        currentRow += dataSet.length + 3;
      }
    });
  }
};

const transposeData = (data) => {
  const transposedData = Object.keys(data[0])
    .map((key) => data.map((row) => row[key]))
    .flat();

  return transposedData;
};

const transposeColumns = (columns, otherSheetData, t) => {
  const temperature = otherSheetData[0]["temperature"];
  const volume = otherSheetData[0]["volume"];
  const currency = otherSheetData[0]["currency"];
  const mass = otherSheetData[0]["mass"];
  return Object.keys(columns).map((key) => {
    let columnValue = columns[key].replace("$", CURRENCY_UNITS[currency]);
    if (columnValue.includes(t("OthersTableStrings.cipWaterPrice"))) {
      columnValue = columnValue.replace("<unit>", volume);
    } else if (
      columnValue.includes(t("OthersTableStrings.defaultCIPAcidPrice")) ||
      columnValue.includes(t("OthersTableStrings.defaultCIPAlkaliPrice")) ||
      columnValue.includes(t("OthersTableStrings.defaultCIPAdditivePrice")) ||
      columnValue.includes(t("OthersTableStrings.acid_used_per_cip")) ||
      columnValue.includes(t("OthersTableStrings.alkali_used_per_cip")) ||
      columnValue.includes(t("OthersTableStrings.additional_chemical_per_cip"))
    ) {
      columnValue = columnValue.replace("<unit>", mass);
    } else {
      columnValue = columnValue.replace("<unit>", temperature);
    }
    return columnValue;
  });
};

export const exportAllTables = async (
  downloadFileName,
  exportData,
  foulingType,
  t,
  selectedTrain,
) => {
  // If cleanData is not present, fetch it from API
  let finalExportData = { ...exportData };
  if (!finalExportData.cleanData && selectedTrain) {
    try {
      const response = await cleanedData(selectedTrain);
      if (response?.data?.cleaned_data) {
        const data = JSON.parse(response.data.cleaned_data);
        finalExportData.cleanData = data;
        finalExportData.units = response.data.units;
      }
    } catch (err) {
      console.error("Error fetching cleanedData for export:", err);
      // Continue with export even if cleanData fetch fails
    }
  }

  // Process cleanData before sending to worker
  if (finalExportData.cleanData) {
    const processedResult = processCleanDataForExcel(
      finalExportData.cleanData,
      finalExportData.units,
    );
    if (processedResult) {
      finalExportData.processedDataSheetData = processedResult.data;
      finalExportData.processedDataUnits = processedResult.units;
    }
    delete finalExportData.cleanData; // Remove raw cleanData as it's no longer needed
  }

  const worker = new WebWorker(dataDownloaderWorker);

  const translations = {
    exportWorkerTransaltionString: t("exportWorkerTransaltionString", {
      returnObjects: true,
    }),
  };
  worker.postMessage({
    exportData: finalExportData,
    translations,
    foulingType,
  });
  worker.onerror = (error) => console.log("Error in Worker:", error);
  worker.onmessage = (event) => {
    const {
      predicitionSheetData,
      benefitSheetDataMessage,
      benefitSheetData,
      annualBenefitSheetDataMessage,
      annualBenefitSheetData,
      comparisonSheetData,
      comparisonSheetDataMessage,
      cipSheetData,
      cleaningEffectinessSheetData,
      foulingSheetData,
      otherSheetData,
      suggestedOtherSheetData,
      processedDataSheetData,
    } = event.data;

    const workbook = new ExcelJS.Workbook();

    const messages = [
      "",
      comparisonSheetDataMessage,
      benefitSheetDataMessage,
      annualBenefitSheetDataMessage,
    ];
    createCleaningAdvisorPredictExcelSheet(
      workbook,
      t("excelSheetNames.predict"),
      [
        predicitionSheetData,
        benefitSheetData,
        annualBenefitSheetData,
        comparisonSheetData,
      ],
      messages,
      t,
    );
    const temperature = otherSheetData[0]["temperature"];
    const mass = otherSheetData[0]["mass"];
    const HistoricCipTableStringsObj = t("HistoricCipTableStrings", {
      returnObjects: true,
    });

    Object.entries(HistoricCipTableStringsObj).forEach(([key]) => {
      const isMassUnit = MASS_KEYS.includes(key);
      const unit = isMassUnit ? mass : temperature;
      HistoricCipTableStringsObj[key] = t(`HistoricCipTableStrings.${key}`, {
        unit,
      });
    });
    createCleaningAdvisorExcelSheet(
      workbook,
      cipSheetData,
      HistoricCipTableStringsObj,
      t("excelSheetNames.historicalCIPS"),
      t,
    );
    const HistoricalCIPEffectivnessTableStringsObj = t(
      "HistoricalCIPEffectivnessTableStrings",
      { returnObjects: true },
    );
    createCleaningAdvisorExcelSheet(
      workbook,
      cleaningEffectinessSheetData,
      HistoricalCIPEffectivnessTableStringsObj,
      t("excelSheetNames.cleaningEffectivness"),
      t,
    );
    const FoulingTableStringsObj = t("FoulingTableStrings", {
      returnObjects: true,
    });
    createCleaningAdvisorExcelSheet(
      workbook,
      foulingSheetData,
      FoulingTableStringsObj,
      t("excelSheetNames.fouling"),
      t,
    );

    const OthersTableStringsObj = t("OthersTableStrings", {
      returnObjects: true,
    });
    const transposedOtherSheetData = transposeData(otherSheetData);
    const transposedOtherSheetColumn = transposeColumns(
      OthersTableStringsObj,
      otherSheetData,
      t,
    );

    // Build transposed suggested data aligned to the same keys as the others object
    let transposedSuggestedData = null;
    if (suggestedOtherSheetData && suggestedOtherSheetData.length > 0) {
      transposedSuggestedData = Object.keys(otherSheetData[0]).map(
        (key) => suggestedOtherSheetData[0][key] ?? "",
      );
    }

    createCleaningAdvisorExcelSheet(
      workbook,
      transposedOtherSheetData,
      transposedOtherSheetColumn,
      t("excelSheetNames.others"),
      t,
      true,
      transposedSuggestedData,
    );

    // Add Processed Data sheet with cleaned data used for plotting
    // Always create the sheet, show message if no data available
    createProcessedDataExcelSheet(
      workbook,
      processedDataSheetData,
      t("excelSheetNames.processedData") || "Processed Data",
      t,
      finalExportData.processedDataUnits,
    );

    saveExcelFile(downloadFileName, workbook);
    worker.terminate();
  };
};

export default exportAllTables;
